import {
  CampaignPlatformTypeEnum,
  SpotifyCampaign,
  TiktokCampaign,
  TikTokCampaignPricingModelEnum,
} from 'src/Types/campaigns'

import { MetaCampaign } from '../ad-campaignApi'

import {
  MetaCampaignsListResponse,
  SpotifyCampaignsListResponse,
  TikTokCampaignsListResponse,
} from './api-actions'

export const mapSpotifyCampaign = (
  spotifyData: SpotifyCampaignsListResponse,
): Array<SpotifyCampaign> =>
  spotifyData?.map((campaign) => ({
    id: Number(campaign.id),
    type: campaign.type,
    trackCoverUrl: campaign.trackImage,
    trackTitle: campaign.trackName,
    trackAuthorName: campaign.artistName,
    startDate: campaign.startDate,
    endDate: campaign.endDate,
    status: campaign.status,
    platformType: CampaignPlatformTypeEnum.SPOTIFY,
    relaunched: campaign.relaunched,
    reviewedReviews: campaign.reviewedReviews,
    matchingType: campaign.matchingType,
    createdAt: campaign.createdAt,
    isPreRelease: campaign.isPreRelease,
    releaseDate: campaign.releaseDate,
    placementsCount: campaign.placementsCount,
    trackSpotifyId: campaign.trackSpotifyId,
  }))

export const mapTiktokCampaign = (
  tiktokData: TikTokCampaignsListResponse,
): Array<TiktokCampaign> =>
  tiktokData?.campaigns?.map((campaign) => ({
    id: String(campaign.id),
    type: campaign.type,
    trackCoverUrl: campaign.trackCoverUrl,
    trackTitle: campaign.trackTitle,
    trackAuthorName: campaign.trackAuthorName,
    startDate: campaign.startDate,
    endDate: campaign.endDate,
    status: campaign.status,
    platformType: CampaignPlatformTypeEnum.TIKTOK,
    createdAt: campaign.createdAt,
    submittedVideosAmount: campaign.submittedVideosAmount,
    influencersAcceptedAmount: campaign.influencersAcceptedAmount,
    trackDuration: 0,
    genres: [],
    languages: [],
    trackId: 0,
    price: 0,
    isCurrent: false,
    expectedMinVideos: 0,
    expectedMaxVideos: 0,
    expectedMaxViews: 0,
    expectedMinViews: 0,
    refund: 0,
    totalVideos: 0,
    totalViews: 0,
    totalShares: 0,
    relaunched: false,
    reviews: { done: 0, influencersAcceptedCount: 0 },
    pricingModel: TikTokCampaignPricingModelEnum.FollowersBased,
    commentType: '',
    spent: 0,
    reserved: 0,
  }))

export const mapMetaCampaigns = (
  metaData: MetaCampaignsListResponse,
): Array<MetaCampaign> =>
  metaData?.map(
    (campaign) =>
      ({
        id: campaign.id,
        createdAt: campaign.createdAt,
        endDate: campaign.endDate,
        startDate: campaign.startDate,
        platformType: CampaignPlatformTypeEnum.META,
        status: campaign.status,
        trackAuthorName: campaign.ownerName,
        trackTitle: campaign.resourceName,
        trackCoverUrl: campaign.coverUrl,
        submittedVideosAmount: campaign.submittedVideosAmount,
      }) as MetaCampaign,
  )
